import * as helper from '@/store/helpers'
import { defineStore } from 'pinia'

/** Два ISO-значения для API: начало первого дня UTC и начало дня после последнего (как на бэкенде). */
export function newsDateRangeParams(start, end) {
    if (start == null || end == null) return []
    return [start, end].map((date, index) => {
        const d = new Date(date.getTime())
        d.setUTCHours(0, 0, 0, 0)
        if (index === 1) d.setUTCDate(d.getUTCDate() + 1)
        return d.toISOString()
    })
}

export const useNewsStore = defineStore('news', {
    state() {
        return {
            allNews: [],
            singleNews: {},
            newsCategories: [],
            newsEvent: {}
        }
    },
    actions: {
        async getNews(start, end, searchString = '', searchDates = [], categoriesId = []) {
            let data = {
                start,
                end,
                search_string: searchString,
                dates: newsDateRangeParams(searchDates[0], searchDates[1]),
                categories_id: categoriesId
            }
            this.allNews = await helper.api('GET', '/news_with_conferences_and_seminars/', data)
        },

        async getSingleNews(newsId) {
            this.singleNews = await helper.api('GET', `/news/${newsId}`, {})
        },

        async getNewsCategories() {
            this.newsCategories = await helper.api('GET', '/news/categories', {})
        },

        async getNewsEvent(eventId) {
            this.newsEvent = await helper.api('GET', `/events/${eventId}`, {})
        }

    }
})
